import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledCobrandWrapper = styled.div`
  ${rtl`
    .variable_column_header {
      margin: 0;

      p {
        margin-bottom: 0;
      }
    }

    .cobrand-wrapper-height {
      min-height: ${toRem(4400)};

      @media ${baseVariables.mediaQuery.md} {
        min-height: ${toRem(6300)};
      }

      @media ${baseVariables.mediaQuery.lg} {
        min-height: ${toRem(5300)};
      }
    }

    .vcc-container {
      margin-bottom: 0;
    }

    .cobrand-wrapper.ecm-hub-dashboard {
      padding: ${toRem(48)} 0;
      .vcc-container {
        .variable_column_content .layout-wrapper {
          display: grid;
          gap: ${toRem(24)};
          align-items: start;
          grid-template-columns: 1fr;
          grid-template-areas: 'primary' 'secondary' 'left' 'right' 'bottom';
          min-width: 0;
          .item-primary {
            grid-area: primary;
            min-width: 0;
          }
          .item-secondary {
            grid-area: secondary;
            min-width: 0;
            .card-container{
              margin: 0 ${toRem(-16)};
              border-radius: 0;
              @media ${baseVariables.mediaQuery.md} {
               margin: unset;
               border-radius: ${toRem(14)};
              }
            }
          }
          .item-left {
            grid-area: left;
            min-width: 0;
          }
          .item-right {
            grid-area: right;
            min-width: 0;
          }
          .item-bottom {
            grid-area: bottom;
            min-width: 0;
          }

          @media ${baseVariables.mediaQuery.md} {
            /* 1:1 — each column = 50% minus half the 24px gap */
            grid-template-columns: calc(50% - ${toRem(12)}) calc(50% - ${toRem(12)});
            grid-template-areas: 'primary primary' 'secondary secondary' 'left right' 'bottom bottom';

            .item-left,
            .item-right {
              align-self: stretch;
            }
            .item-left > *,
            .item-right > * {
              height: 100%;
            }
          }

          @media ${baseVariables.mediaQuery.lg} {
            /* 2:1 — left ~66.67%, right ~33.33% with proportional gap compensation */
            grid-template-columns: calc(64% - ${toRem(16)}) calc(36% - ${toRem(8)});
            grid-template-areas: 'primary primary' 'secondary secondary' 'left right' 'bottom bottom';
          }

          @media ${baseVariables.mediaQuery.xl} {
           grid-template-columns: calc(66.67% - ${toRem(16)}) calc(33.33% - ${toRem(8)});
            grid-template-areas: 'primary primary' 'secondary right' 'left right' 'bottom bottom';
          }
        }
        .column-containers.col-12{
          padding: 0;
        }
      }
    }

    .full-skeleton-block {
      border: ${baseVariables.border.borderWidth02} ${baseVariables.border.borderStyleDefault} ${
    baseVariables.color.neutral20
  };
      border-radius: ${toRem(16)};
      box-shadow: 0 ${toRem(4)} ${toRem(20)} ${baseVariables.shadows.boxShadowTile};
      overflow: hidden;

      .react-loading-skeleton {
        --pseudo-element-display: true;
      }
    }

    .personal-wrapper {
      @media ${baseVariables.mediaQuery.allTablets} {
        width: 100%;
        max-width: unset;
      }

      @media ${baseVariables.mediaQuery.xl} {
        width: 872px !important;
        max-width: 872px !important;
      }

      ul {
        max-width: fit-content;
      }
    }

    .business-wrapper {
      border-radius: ${toRem(14)};
      background-color: ${baseVariables.color.base20};
      box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);
      padding-top: ${toRem(48)};

      @media ${baseVariables.mediaQuery.md} {
        width: max-content !important;
        max-width: max-content !important;
        margin: ${toRem(24)} auto 0 auto;
      }

      @media ${baseVariables.mediaQuery.lg} {
        padding-right: ${toRem(24)};
        padding-left: ${toRem(24)};
      }

      @media ${baseVariables.mediaQuery.xl} {
        max-width: ${toRem(242)} !important;
        padding-right: 0;
        padding-left: 0;
        margin-top: 0;
        margin-right: 0;
      }

      .layout-wrapper,
      .aem-container,
      .aem-container > div,
      .card-overview {
        height: 100%;
      }
    }

    .no-list-style ul {
      display: flex;
      list-style-type: none !important;
    }

    .card-tag {
      position: absolute;
      top: 0;
      left: 0;
      width: fit-content;
      padding: ${toRem(4)} ${toRem(16)};
      margin-bottom: ${toRem(24)};
      line-height: ${toRem(14)};
      border-radius: ${toRem(8)} ${toRem(0)} ${toRem(4)} ${toRem(0)};
      background-color: ${baseVariables.color['neutral10']};
      color: ${baseVariables.color['base10']};
      text-transform: capitalize;
      font-size: ${toRem(14)};
      font-weight: 700;
    }
    .business-badge {
      background-color: ${baseVariables.color['base10']};
      color: ${baseVariables.color['base20']};
    }

    .column-containers {
      @media ${baseVariables.mediaQuery.lg} {
        padding-right: 0 !important;
        padding-left: 0 !important;
      }
    }

    .layout-wrapper {
      div.aem-container {
        padding-left: ${toRem(8)};
        padding-right: ${toRem(8)};

        @media ${baseVariables.mediaQuery.xl} {
          padding-left: 0;
          padding-right: 0;
        }
      }

      .column-containers,
      .aem-container:first-child {
        @media ${baseVariables.mediaQuery.md} {
          gap: 0;
        }
      }
    }
  .custom-padding .card-overview-wrapper {
    padding-top: ${toRem(130)};
    @media ${baseVariables.mediaQuery.md} {
      padding-top: ${toRem(80)};
    }
  }
  ul.variable_column_content:has(> li) {
    list-style: none;
  }
  `}
`;
